// 다운로드 페이지(views/Donwload/Downloads.js)용 환경별 고정 다운로드 링크.
//
// 배경: 기존에는 BE API(/v2/thirdparty/deliverycatch/download)가 DB 에 저장된 링크를 내려줬으나,
// 값 갱신이 누락되어 옛 인스톨러 경로가 한 달 넘게 방치되고 설치 오류가 발생했다.
// 그래서 게시 스크립트(window.deliverycatch.store/tool/publish.ps1)가 게시할 때마다 갱신하는
// catch-admin 원래 경로의 "안정키"(버전 번호가 없는 고정 파일명)를 직접 가리키도록 바꿔, API·DB 의존 없이 항상 최신본이 나가게 한다.
// ⛔ 상용·서브용 인스톨러 정본은 catch-admin/download/store 다(저장소 이동 없음 결정, 2026-09-08 재확인).
//
// 주의: 안정키의 파일명·경로를 바꾸면 publish.ps1 쪽도 함께 바꿔야 한다.

const PROD_LINKS = {
  adminWeb: {
    // 관제 APP - 플레이스토어 정식 배포
    aos: 'https://play.google.com/store/apps/details?id=com.deliverycatch.admin',
    // 관제 WEB
    web: 'https://admin.deliverycatch.com/',
  },
  store: {
    // 캐치상점 POS 설치파일 - catch-admin 원래 경로(정본). publish.ps1 이 게시마다 덮어쓴다
    exe: encodeURI(
      'https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/store/캐치상점.exe'
    ),
    // 캐치상점 POS 압축파일 - catch-admin 고정 경로
    zip: encodeURI(
      'https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/store/캐치상점.zip'
    ),
    // 서브용 가맹점 프로그램 - catch-admin 원래 경로(정본)
    sub: encodeURI(
      'https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/store/[서브용]캐치상점.exe'
    ),
    // 가맹점 APP - 플레이스토어 정식 배포
    aos: 'https://play.google.com/store/apps/details?id=com.deliverycatch.store',
    // 가맹점 APP - 앱스토어 정식 배포
    ios: 'https://apps.apple.com/kr/app/%EC%BA%90%EC%B9%98%EC%83%81%EC%A0%90/id6756643129',
  },
  rider: {
    // 기사 APP - 플레이스토어 정식 배포
    aos: 'https://play.google.com/store/apps/details?id=com.deliverycatch.riders',
  },
};

const DEV_LINKS = {
  adminWeb: {
    // 관제 APP - Firebase App Distribution
    aos: 'https://appdistribution.firebase.dev/i/287dd0eae5f83ff0',
    // 관제 WEB (dev)
    web: 'https://devadmin.deliverycatch.com/',
  },
  store: {
    // 캐치상점 POS 설치파일(dev) - S3 dev 안정키
    exe: encodeURI(
      'https://deliverycatch-deploy-artifacts.s3.ap-northeast-2.amazonaws.com/pos/installer/dev/[DEV]캐치상점.exe'
    ),
    // 캐치상점 POS 압축파일 - prod 와 동일 값(zip 은 dev/prod 구분 없이 같은 경로 사용)
    zip: PROD_LINKS.store.zip,
    // 서브용 가맹점 프로그램 - dev 채널이 없어 prod 와 동일 값 사용
    sub: PROD_LINKS.store.sub,
    // 가맹점 APP - Firebase App Distribution
    aos: 'https://appdistribution.firebase.dev/i/287dd0eae5f83ff0',
    // 가맹점 APP (ios) - prod 와 동일
    ios: PROD_LINKS.store.ios,
  },
  rider: {
    // 기사 APP - Firebase App Distribution
    aos: 'https://appdistribution.firebase.dev/i/287dd0eae5f83ff0',
  },
};

const downloadLinks = process.env.REACT_APP_ENVIRONMENT === 'dev' ? DEV_LINKS : PROD_LINKS;

export default downloadLinks;
